module.exports = __webpack_public_path__ + "static/img/anxunMobel24.4ec5f1b0.png";